const isLastCharEqualToFirstChar = (string) => {
  if (!string) { return false }
  if (string.length < 3) { return false }

  if (string.substr(string.length - 1) === string.substr(0, 1)) {
    return true
  }

  return false
}

export default isLastCharEqualToFirstChar
